<template>
  <div style="width:100%;">
    <v-container>
      <v-form @submit="editTask">
        <v-card style="width:100%;margin-left:auto;margin-right:auto;" outlined>
          <v-card-title>
            <h3>{{ $t("edittask.header") }}</h3>
          </v-card-title>
          <v-card-text style="padding:15px;">
            <v-text-field type="text" :label="$t('edittask.name')" v-model="name"></v-text-field>
            <v-textarea v-model="description" :label="$t('edittask.description')"></v-textarea>
            <v-select :label="$t('edittask.interval')" v-model="interval" :items="intervals"></v-select>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" text type="submit">{{$t('edittask.save')}}</v-btn>
            <v-btn color="default" text type="button" @click="cancel">{{$t('edittask.cancel')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import { Notifications } from "../notification";
import { storage } from "../schmucklicloud";

import intervals from "../assets/data/intervals";

export default {
  data() {
    return {
      id: 0,
      name: "",
      description: "",
      interval: "",
      intervals: intervals.map(entry => { entry.text = this.$t(entry.text); return entry;})
    };
  },
  async mounted() {
    this.id = this.$route.params.id;
    var response = await storage.getById("tasks", this.id);
    if (response.isOK) {
      var data = response.data.data;
      this.name = data.name;
      this.description = data.description;
      this.interval = parseInt(data.interval);
    } else {
      this.$router.replace("/");
    }
  },
  methods: {
    async editTask(e) {
      e.preventDefault();
      var response = await storage.update("tasks", this.id, {
        name: this.name,
        description: this.description,
        interval: this.interval
      });
      if (response.status_code === 200) {
        this.$router.replace("/task/" + this.id);
        Notifications.show(this.$t("edittask.notification.task_updated"));
      } else {
        Notifications.show(response.message);
      }
    },
    cancel() {
      this.$router.replace("/task/" + this.id);
    }
  }
};
</script>

<style>
</style>